import { userRequest } from "./requestMethods";

/**
 * The growth offers the server says apply to this shopper, and their invite
 * details. The server decides eligibility and amounts; these only read them.
 *
 *   GET /api/growth/offers  (guest or signed in)
 *     { firstOrderFreeDelivery: { enabled, cap, eligible }, referral: { enabled },
 *       freeDeliveryCredits, nextOrderOffer,
 *       offerToShow: { kind, cap, signedIn } | null }   the one offer to advertise
 *   GET /api/growth/home-facts  (public)
 *     { vendorCount: number|null, leadAction: "FOOD"|"GROCERIES" }  the homepage's
 *     live vendor count (rounded down) and which of its buttons leads now
 *   GET /api/referrals/me   (signed in)
 *     { code, shareUrl, invitedCount, rewardedCount, freeDeliveryCredits }
 */
export const fetchGrowthOffers = async () => {
  const response = await userRequest.get("/api/growth/offers");
  return response.data;
};

export const fetchMyReferral = async () => {
  const response = await userRequest.get("/api/referrals/me");
  return response.data;
};

export const fetchHomeFacts = async () => {
  const response = await userRequest.get("/api/growth/home-facts");
  return response.data;
};
